module.exports = __webpack_public_path__ + "static/media/20b.3c2e5aa8.jpg";